<palantir-avatar [fallbackText]="label">
  @if (value) {
    <img [src]="value" [alt]="label" />
  } @else {
    <palantir-icon [name]="icon" />
  }
</palantir-avatar>

@if (label) {
  <palantir-text type="text" [palantirTooltip]="label" truncate="true">
    {{ label }}
  </palantir-text>
}
